module.exports = __webpack_public_path__ + "media/images/common/hall_of_fame_bg_btm-a039e3baf2539c9301b5bb30ff15024a.gif";